import ClientUtils from '../utils/http-clients';
import Settings from '../resources/settings';

/**
 * We will always pass both educator and partner bid to the backend.
 * It will determine (based on role) which reports to return to queue.
 */

export default {
  getReports: (educatorBid, partnerBid, requestParams) => {
    const url = `${Settings.BATCH_REPORT_FAMILY_REPORT}?educator_bid=${educatorBid}&partner_bid=${partnerBid}`;
    return ClientUtils.makeGetRequest(url, requestParams);
  },
  deleteReports: (educatorBid, requestIds, requestParams) => {
    const url = `${Settings.BATCH_REPORT_FAMILY_REPORT}`;
    return ClientUtils.makePutRequest(
      url,
      {
        educator_bid: educatorBid,
        request_ids: requestIds,
      },
      requestParams
    );
  },
  getDownloadUrl: (educatorBid, requestId, requestParams) => {
    const url = `${Settings.BATCH_REPORT_FAMILY_REPORT_DOWNLOAD}?educator_bid=${educatorBid}&request_id=${requestId}`;
    return ClientUtils.makeGetRequest(url, requestParams);
  },

  retryReport: (partnerBid, requestId, createdAt, requestParams) => {
    const url = Settings.BATCH_REPORT_RETRY;

    const requestBody = {
      request_id: requestId,
      createdAt: createdAt,
      partner_bid: partnerBid,
    };

    const config = {
      headers: {
        ...requestParams?.headers,
      },
      ...requestParams, // Include other config like cancelToken if present
    };

    return ClientUtils.makePostRequest(url, requestBody, config);
  },
};
